import React from "react";
import clientsData from "../data/clients.json";
import "../styles/clientsStyle.css";

const Clients = () => {
  const governmentLogos = clientsData.government.map((logo) => (
    <img
      key={logo}
      src={require(`../assets/clients/GOVT-Client/${logo}`)}
      
      alt="Government Client"
      loading="lazy"
    />
  ));
  
  const corporateLogos = clientsData.corporate.map((logo) => (
    <img
      key={logo}
      src={require(`../assets/clients/Corporate-Client/${logo}`)}
      alt="Corporate Client"
      loading="lazy"
    />
  ));
  

  return (
    <div className="clients-container">
      {/* <h2 className="gov-heading container">Government & PSU Clients</h2>
      <div className="government-logos">
        {governmentLogos}
        {governmentLogos}
        {governmentLogos}
        {governmentLogos}
        {governmentLogos}
        {governmentLogos}
        {governmentLogos}
        {governmentLogos}
        {governmentLogos}
        {governmentLogos}
        {governmentLogos}
        {governmentLogos}
        {governmentLogos}
        {governmentLogos}
      </div> */}
      <h2 className="corp-heading container">Our Clients</h2>
      <div className="corporate-logos">
        {corporateLogos}
        {corporateLogos} 
        {corporateLogos}
        {corporateLogos}
        {corporateLogos}
        {corporateLogos}
        {corporateLogos}
        {corporateLogos}
        {corporateLogos}
        {corporateLogos}
        {corporateLogos}
        {corporateLogos}
        {corporateLogos}
        {corporateLogos}
        {corporateLogos}
        {corporateLogos}
        {corporateLogos}
        {corporateLogos}
        {corporateLogos}
        {corporateLogos}
        {corporateLogos}
        {corporateLogos}
      </div>
    </div>
  );
};

export default Clients;
